const now = +new Date();
let index = 0;

export function getUid() {
  return `cds-uploader-${now}-${++index}`;
}
